export abstract class BaseTooltip {
    public abstract data: any; // Data supplied to this tooltip is put in this property by the tooltip component when it injects it

    /**
     * A method that is added from the tooltip component and which closes the tooltip. This is called whenever the tooltip needs to close for whatever reason.
     * @param {Object} data
     */
    public closeTooltipInstance(data?: any): void {}
}
